import I18n from '../../config/i18n';

import { stringArrayToObject } from '../../utils/array';

import {
  loadAccountProfile, updateCompanyInfo, updateUserInfo, updatePassword,
} from '../../services/AccountService';

import { actionCreators as authActions } from '../Auth/actions';
import { actionCreators as toastActions } from '../Toasts/actions';

export const actions = stringArrayToObject([
  'CLEAR',
  'LOAD_START',
  'LOAD_SUCCESS',
  'LOAD_FAIL',
  'UPDATE_START',
  'UPDATE_SUCCESS',
  'UPDATE_PASSWORD_SUCCESS',
  'UPDATE_FAIL',
], '@@PROFILE');

const privateActionCreators = {
  loadStart() {
    return {
      type: actions.LOAD_START,
    };
  },
  loadSuccess(profile) {
    return {
      type: actions.LOAD_SUCCESS,
      payload: { profile },
    };
  },
  loadFail(error) {
    return {
      type: actions.LOAD_FAIL,
      payload: { error },
    };
  },
  updateStart() {
    return {
      type: actions.UPDATE_START,
    };
  },
  updateSuccess(data) {
    return {
      type: actions.UPDATE_SUCCESS,
      payload: { data },
    };
  },
  updatePasswordSuccess() {
    return {
      type: actions.UPDATE_PASSWORD_SUCCESS,
    };
  },
  updateFail(error) {
    return {
      type: actions.UPDATE_FAIL,
      payload: { error },
    };
  },
};

export const actionCreators = {
  clear() {
    return {
      type: actions.CLEAR,
    };
  },
  load() {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadStart());
      const response = await loadAccountProfile();
      if (response.ok) {
        dispatch(privateActionCreators.loadSuccess(response.profile));
      } else {
        dispatch(privateActionCreators.loadFail(response.error));
      }
    };
  },
  updateUser(data) {
    return async (dispatch) => {
      dispatch(privateActionCreators.updateStart());
      const response = await updateUserInfo(data);
      if (response.ok) {
        dispatch(privateActionCreators.updateSuccess(response.profile));
        // We refresh our auth to update our new auth info
        dispatch(authActions.refresh());
      } else {
        dispatch(privateActionCreators.updateFail(response.error));
      }
    };
  },
  updateCompany(data) {
    return async (dispatch) => {
      dispatch(privateActionCreators.updateStart());
      const response = await updateCompanyInfo(data);
      if (response.ok) {
        dispatch(privateActionCreators.updateSuccess(response.profile));
        // We refresh our auth to update our new auth info
        dispatch(authActions.refresh());
      } else {
        dispatch(privateActionCreators.updateFail(response.error));
      }
    };
  },
  updatePassword(data) {
    return async (dispatch) => {
      dispatch(privateActionCreators.updateStart());
      const response = await updatePassword(data);
      if (response.ok) {
        dispatch(privateActionCreators.updatePasswordSuccess());
        dispatch(authActions.init(response.user));
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18n.t('collection.messages.passwordChanged'),
        }));
      } else {
        dispatch(privateActionCreators.updateFail(response.error));
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18n.t('account.errors.passwordChangeFailed'),
        }));
      }
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/Profile/actions.js